import { atom } from 'jotai'
import { SelectedEntity } from 'src/v2/types/core'

export const supportedSelections = atom<SelectedEntity['type'][] | undefined>(undefined)
